import React from "react";
import "./CaminhoRato.css";

const CaminhoRato = ({caminho, divisor}) => {
    //console.log("CAMINHO",caminho);
    return (
        <span className="caminhoRato">
            {
                divisor ? caminho.split(divisor).map((item, index) => {
                    return (
                        <span key={index}>
                            {index > 0 ? <span> / </span> : ''}
                            {item}
                        </span>
                    )
                }) : caminho
            }
        </span>
    )
}
export default CaminhoRato;